import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoSituacao } from '../models/projeto-situacao.model';

@Injectable()
export class ProjetoSituacaoService extends BaseService<ProjetoSituacao> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-situacao';
  }
}
